import { render, staticRenderFns } from "./MedalIcon.vue?vue&type=template&id=410f417e"
import script from "./MedalIcon.vue?vue&type=script&lang=js"
export * from "./MedalIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports